var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-warning-50 p-y-3 p-x-6 radius-16 d-flex align-items-center gap-6"},[_c('Shield',{attrs:{"color":"var(--warning-700)"}}),_c('p',{staticClass:"text-warning-700 p-small-medium"},[_vm._v(" "+_vm._s(_vm.$t("labels.passwordCreationPending"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }